import filter from "./filter";
import directive from "./directive";

export default Vue => {
  //指令
  directive(Vue);
  //过滤器
  filter(Vue);
  // 全局通信 使用 $on:注册事件 使用 $emit:触发
  Vue.prototype.$eventHub = new Vue();
};



// WEBPACK FOOTER //
// ./src/core/core.config.js